// Modern iOS detection with userAgentData fallback
// async function detectiOS() {
//   // Check if userAgentData is available (Chromium-based browsers)
//   if (navigator['userAgentData']) {
//     try {
//       // Get high entropy values for more detailed detection
//       const highEntropyValues = await navigator[
//         'userAgentData'
//       ].getHighEntropyValues([
//         'platform',
//         'platformVersion',
//         'model',
//         'mobile',
//       ]);

//       // Check for iOS indicators
//       const platform = highEntropyValues.platform?.toLowerCase();
//       const mobile = highEntropyValues.mobile;

//       // iOS detection via userAgentData
//       if (platform === 'ios' || platform === 'ipados') {
//         return {
//           isIOS: true,
//           method: 'userAgentData',
//           platform: platform,
//           mobile: mobile,
//           platformVersion: highEntropyValues.platformVersion,
//           model: highEntropyValues.model,
//         };
//       }

//       // Check basic mobile flag and platform for potential iOS
//       if (mobile && (platform === 'unknown' || !platform)) {
//         // Additional checks might be needed
//         return {
//           isIOS: false,
//           method: 'userAgentData',
//           mobile: mobile,
//           platform: platform,
//           note: 'Mobile device detected but not confirmed iOS',
//         };
//       }
//     } catch (error) {
//       console.log('userAgentData high entropy values not available:', error);
//     }

//     // Fallback to basic userAgentData
//     const brands = navigator['userAgentData'].brands || [];
//     const mobile = navigator['userAgentData'].mobile;

//     // Check brands for any iOS indicators (though unlikely in current implementation)
//     const hasIOSBrand = brands.some(
//       (brand) =>
//         brand.brand.toLowerCase().includes('ios') ||
//         brand.brand.toLowerCase().includes('iphone') ||
//         brand.brand.toLowerCase().includes('ipad')
//     );

//     if (hasIOSBrand) {
//       return {
//         isIOS: true,
//         method: 'userAgentData-brands',
//         mobile: mobile,
//         brands: brands,
//       };
//     }
//   }

//   // Fallback to traditional userAgent detection
//   return detectiOSFallback();
// }

function detectiOSFallback() {
  const userAgent = navigator.userAgent || '';

  // Traditional iOS detection
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window['MSStream'];

  // Enhanced detection for modern iOS (handles iPad on iOS 13+)
  const isIOSEnhanced =
    isIOS ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOSEnhanced) {
    // Determine device type
    let deviceType = 'unknown';
    if (
      /iPad/.test(userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) {
      deviceType = 'iPad';
    } else if (/iPhone/.test(userAgent)) {
      deviceType = 'iPhone';
    } else if (/iPod/.test(userAgent)) {
      deviceType = 'iPod';
    }

    return {
      isIOS: true,
      method: 'userAgent-fallback',
      deviceType: deviceType,
      userAgent: userAgent,
    };
  }

  return {
    isIOS: false,
    method: 'userAgent-fallback',
    userAgent: userAgent,
  };
}

// Synchronous version for immediate use
export function detectiOS() {
  // Quick check with basic userAgentData
  if (navigator['userAgentData']) {
    const mobile = navigator['userAgentData'].mobile;
    const brands = navigator['userAgentData'].brands || [];

    // Check for iOS brands (though currently not implemented by browsers)
    const hasIOSBrand = brands.some(
      (brand) =>
        brand.brand.toLowerCase().includes('ios') ||
        brand.brand.toLowerCase().includes('iphone') ||
        brand.brand.toLowerCase().includes('ipad')
    );

    if (hasIOSBrand) {
      return {
        isIOS: true,
        method: 'userAgentData-sync',
        mobile: mobile,
      };
    }
  }

  // Fallback to userAgent
  return detectiOSFallback();
}

// Usage examples:

// Async detection (recommended)
// detectiOS().then((result) => {
//   console.log('iOS Detection Result:', result);

//   if (result.isIOS) {
//     console.log('Running on iOS device');
//     // Apply iOS-specific behavior
//   }
// });

// Feature detection approach (often better than device detection)
function supportsIOSFeatures() {
  return {
    touchCallout: CSS.supports('-webkit-touch-callout', 'none'),
    safariAPI: 'safari' in window,
    webkitAppearance: CSS.supports('-webkit-appearance', 'none'),
    hasTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
  };
}
